import { FormGroup, FormSection } from '@ksyos/design-system';
import type { IService } from '@common/interfaces/';
import { ServiceCode } from '@common/enums/';
import { translateKey } from '@frontend/translate';
import { SettingsSwitch } from '../../modals/components/SettingsSwitch';

export interface IReferralSetting {
    error?: string;
    isRecipientIsOwnOrganization: boolean;
    onChange: (isRecipientIsOwnOrganization: boolean) => void;
    onDoValidate?: () => void;
    service: IService;
}

export function RecipientIsOwnOrganizationSetting(props: IReferralSetting) {
    if (props.service.code !== ServiceCode.OSASV) {
        return null;
    }

    return (
        <FormSection title={translateKey('serviceTypeEnum.referralSmall')}>
            <FormGroup
                hasErrors={Boolean(props.error)}
                label={translateKey('addCarePathSettingsLabelsServiceConsumer.referralToSelf')}
            >
                <SettingsSwitch
                    error={props.error}
                    listKey={`referral-${props.service.id}`}
                    onBlur={() => {
                        if (props.onDoValidate) {
                            props.onDoValidate();
                        }
                    }}
                    onChange={props.onChange}
                    value={props.isRecipientIsOwnOrganization}
                />
            </FormGroup>
        </FormSection>
    );
}
